import { Injectable } from '@angular/core';
import { ProjectStateService } from './project-state.service';
import { SSOService } from './sso.service';
import { ADMIN_ROLE_SET, ROLE_NAMES } from '../constants/role.constants';
import { ProjectModel } from '../models/project.model';

@Injectable({
  providedIn: 'root'
})
export class PermissionHelperService {
  constructor(
    private projectStateService: ProjectStateService,
    private ssoService: SSOService
  ) {}

  has(pageKey: string, permissionKey: string): boolean {
    return this.projectStateService.hasPermission(pageKey, permissionKey);
  }

  hasAny(pageKey: string, permissionKeys: string[]): boolean {
    return permissionKeys.some(key => this.has(pageKey, key));
  }

  canViewPage(pageKey: string): boolean {
    return this.has(pageKey, 'VIEW');
  }

  hasAnyForPage(pageKey: string): boolean {
    return this.projectStateService.hasAnyPermissionForPage(pageKey);
  }

  private getRoleName(): string {
    return (this.ssoService.getCurrentUser()?.roleName || '').trim().toLowerCase();
  }

  isSuperAdmin(): boolean {
    return this.getRoleName() === ROLE_NAMES.SUPER_ADMIN;
  }

  canSeeAllProjects(): boolean {
    return this.isSuperAdmin();
  }

  canCreateProject(): boolean {
    return ADMIN_ROLE_SET.has(this.getRoleName());
  }

  canAssignTemplates(): boolean {
    return ADMIN_ROLE_SET.has(this.getRoleName());
  }

  isProjectAdmin(project?: ProjectModel | null): boolean {
    const roleName = (project?.userRoleName || '').trim().toLowerCase();
    return roleName === ROLE_NAMES.ADMIN || roleName === ROLE_NAMES.PROJECT_ADMIN;
  }
}
